module.exports = __webpack_public_path__ + "img/Fond_Carte_Wilwar_XXL_Neutre.958007cf.png";